import React from "react"
import Styles from "./rightNav.less"
import putAwaySvg from "../../../../static/pic/putAway.svg"
import ShowDataList from "../../../../function/hooks/showDataList"
import {connect} from "react-redux"
import {ReducerState} from "../../../../reducer/interface/baseInterface"
import {ComparisonStatus} from "../../../../reducer/interface/controlInterface"

interface RightNavProps {
    comparisonStatus: ComparisonStatus
}

const RightNav: React.FunctionComponent<RightNavProps> = (props) => {
    const showDataList = ShowDataList()
    const cssTitle = `TDA_RIGHT_BOX_NAV`
    const hiddenList = () => {
        if (props.comparisonStatus.status === "success") {
            showDataList.toFalse()
        }
    }
    return (
        <div className={Styles[cssTitle]}>
            <div className={Styles[`${cssTitle}_TEXT`]}>比对详情列表</div>
            <img onClick={() => hiddenList()} alt={""} style={{width: "18px", cursor: "pointer"}} src={putAwaySvg} />
        </div>
    )
}

export default connect((state: ReducerState) => {
    return {
        comparisonStatus: state.control.comparisonStatus,
    }
})(RightNav)
